import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, Table } from 'antd'

import HeroConfigForm from './components/HeroConfigForm'
import { HeroType } from '../../config'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { getHeroConfigs, saveHeroConfig } from '../../modules/hero'

const HeroConfig = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [heroType, setHeroType] = useState('')

  const { heroConfigList, isLoading } = useSelector(
    (state) => ({
      heroConfigList: state.hero.heroConfigList,
      isLoading: state.hero.heroConfigLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getHeroConfigs())
    }

    fetch()
  }, [])

  function onClick(record) {
    setFormData(record)
    setHeroType(HeroType[record.heroType].title)
    setVisible(true)
  }

  function onClose() {
    setFormData({})
    setHeroType('')
    setVisible(false)
  }

  async function onOk(data) {
    await dispatch(saveHeroConfig(data))
    await dispatch(getHeroConfigs())
    setVisible(false)
  }

  const columns = [
    {
      title: 'Hero Type',
      dataIndex: 'heroType',
      key: 'heroType',
      render: (heroType) => <div>{HeroType[heroType].title}</div>
    },
    {
      title: 'Max Locations',
      dataIndex: 'locationCount',
      key: 'locationCount'
    },
    {
      title: 'Radius (Metre)',
      dataIndex: 'radius',
      key: 'radius'
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <Button
          type="primary"
          size="small"
          shape="circle"
          icon="edit"
          onClick={() => {
            onClick(record)
          }}
        />
      )
    }
  ]

  return (
    <Card title="Hero Configuration">
      <Table
        loading={isLoading}
        rowKey={(record) => record.id}
        dataSource={heroConfigList}
        columns={columns}
      />
      <HeroConfigForm
        heroType={heroType}
        visible={visible}
        onClose={onClose}
        onOk={onOk}
        formData={formData}
      />
    </Card>
  )
}

HeroConfig.propTypes = {
  data: PropTypes.object.isRequired,
  UpdateHeroConfig: PropTypes.func.isRequired
}

export default HeroConfig
